import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  // Fills DashboardLayout (100dvh) and stacks Header + body as a column.
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    // Critical: allows the flex child (bodyContainer) to shrink below its
    // content size so overflow/scroll works instead of expanding the page.
    minHeight: 0,
    width: theme.width.full,
    overflow: "hidden",
    background: `${(theme.palette.background as any).primary}!important`,
  },
  pageContainerLeumit: {
    background: `${theme.palette.white.main}!important`,
  },
  // Keeps the header at its intrinsic content height; never shrinks.
  headerSlot: {
    flexShrink: 0,
    width: theme.width.full,
  },
  // Takes all remaining space under the header and scrolls internally.
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    // Critical with flex: 1 — without this, overflow:auto often fails in nested flex.
    minHeight: 0,
    width: theme.width.full,
    background: `${theme.palette.white.main}!important`,
    color: (theme.palette.text as any).main,
    borderTopLeftRadius: "28px",
    borderTopRightRadius: "28px",
    padding: "20px",
    overflow: "auto",
  },
  step_MODALS: {
    background: `${(theme.palette.background as any).default}!important`,
    borderRadius: 0,
  },
  step_MODALS_leumit: {
    borderRadius: 0,
    background: `${theme.palette.white.main}!important`,
  },
});
